import { render, staticRenderFns } from "./navbar-app-logo.vue?vue&type=template&id=5f019ad8&scoped=true&"
import script from "./navbar-app-logo.vue?vue&type=script&lang=js&"
export * from "./navbar-app-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f019ad8",
  null
  
)

export default component.exports